import React, { useEffect } from 'react'
import { LocalStorageService, MixpanelService } from '../../../application/services';
import { useTranslation } from "react-i18next";
import { DoneSuccessfully } from '../../ui'
import { Link } from 'react-router-dom'
import customers_service_etisalat from '../../../assets/img/customers_service_etisalat.svg'
export function Success(props) {
    const { t } = useTranslation();
    return (
        <div className="container" id="page-wrapper">
            <div className="response-wrapper wrapper ">
                <img style={{ marginTop: '15%' }} alt='customers_service' src={customers_service_etisalat} />
                <p><span className='success_message'>{t("success_message")}</span> {t("information_message")}</p>
                <div className="btn-wrapper ">
                    <button className='btn active'>
                        <div className='lose-discount'>
                            <Link to={{ pathname: '/', search: props.location.search }} onClick={() => LocalStorageService.clear()}>{t("return_home")}</Link>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    )
}
export function PolicyPurchased(props) {
    const { t } = useTranslation();
    return (
        <div className="purchase-wrapper wrapper ">
            <DoneSuccessfully />
            <p className='heading success'>{t("payment_success_title")}</p>
            <p className='body-16 text'>{t("payment_success_message")}</p>
            <div className="btn-wrapper static">
                <button className="btn-purchase upload-now" onClick={() => { LocalStorageService.clear(); props.onClick() }}>{t("return_home")}</button>
            </div>
        </div>
    )
}
export function ThankYouPage(props) {
    const { t } = useTranslation();

    useEffect(() => {
        MixpanelService.getInstance().thankyouViewed()
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    return (
        <div className="container" id="page-wrapper">
            <div className="response-wrapper wrapper ">
                <img style={{ marginTop: '20%' }} alt='customers_service' src={customers_service_etisalat} />
                <p> <span>{t("thank_you_message_span")} </span> {t("thank_you_message")} </p>


                <div className="btn-wrapper ">
                    <button className='btn active'>
                        <div className='lose-discount'>
                            <Link to={{ pathname: '/', search: props.location.search }} onClick={() => { LocalStorageService.clear(); MixpanelService.getInstance().clickReturnHome() }}>{t("return_home")}</Link>
                        </div>
                    </button>
                </div>

            </div>
        </div>
    )
}